import { render } from "./head.vue?vue&type=template&id=51aa2506"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"

import "./head.vue?vue&type=style&index=0&id=51aa2506&lang=css"
script.render = render

export default script